import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";
import {convertPersianDateToUniversalDate} from "../../util/DateConvertor";
//import {resolve} from "chart.js/helpers";
//import {paymentStatus} from "../transactions/TransactionsList";
import {paymentStatus} from "../../pages/transactions/TransactionsList";

export class EtekafService {
    constructor() {
        this.httpClient = new HttpClient()
        this.baseUrl = process.env.REACT_APP_BASE_URL
    }

    getCityByProvince(provinceId) {

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }


        return new Promise((resolve, reject) => {
            axios.get(
                `${this.baseUrl}resources/provinces/9/cities`,
                config
            ).then(resolve).catch(reject)
        })
    }

    getEtekafListData(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                "itikaf-periods",
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewEtekaf(title, startDate, endDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                "itikaf-periods",
                {
                    "starDate": convertPersianDateToUniversalDate(startDate),
                    "endDate": convertPersianDateToUniversalDate(endDate),
                    "acceptation": false,
                    "title": title,
                    "rules": "",
                    "description": ""
                }
            ).then(resolve).catch(reject)
        })
    }

    getEtekafDetailData(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `itikaf-periods/${id}`,
            ).then(resolve).catch(reject)
        })
    }

    updateEtekafEnabledState(id, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `itikaf-periods/${id}/acceptations`,
                {},
                {
                    "acceptation": enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    updateEtekafDetail(id, title, startDate, endDate, description, rules) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `itikaf-periods/${id}`,
                {
                    "starDate": startDate,
                    "endDate": endDate,
                    "title": title,
                    "rules": rules,
                    "description": description
                }
            ).then(resolve).catch(reject)
        })
    }

    getHosts(etekafId, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `itikaf-period/${etekafId}/itikaf-hosts`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewEtekafHost(etekafId, title, clerkName, phoneNumber, capacity, gender, citySelectedId, specialPrice, normalPrice, address, description, acceptation) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `itikaf-period/${etekafId}/itikaf-hosts`,
                {
                    "capacity": capacity,
                    "gender": gender,
                    title,
                    "description": description,
                    "address": address,
                    "clerkFullName": clerkName,
                    "clerkPhoneNumber": phoneNumber,
                    "acceptation": acceptation,
                    "specialPrice": specialPrice,
                    "normalPrice": normalPrice,
                    "selectedCity": {
                        "id": citySelectedId
                    }
                }
            ).then(resolve).catch(reject)
        })
    }

    getEtekafHostDetail(etekafId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `itikaf-hosts/${etekafId}`,
            ).then(resolve).catch(reject)
        })
    }

    updateEtekafHostDetail(id, title, clerkName, phoneNumber, capacity, gender, citySelectedId, specialPrice, normalPrice, address, description, acceptation) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `itikaf-hosts/${id}`,
                {
                    "capacity": capacity,
                    "gender": gender,
                    "title": title,
                    "description": description,
                    "address": address,
                    "clerkFullName": clerkName,
                    "clerkPhoneNumber": phoneNumber,
                    "acceptation": acceptation,
                    "specialPrice": specialPrice,
                    "normalPrice": normalPrice,
                    "selectedCity": {
                        "id": citySelectedId
                    }
                }
            ).then(resolve).catch(reject)
        })
    }

    getRegisterInfo(page, size, id, nationalCode, hostId, cityId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `itikaf-periods/${id}/itikaf-reservations`,
                {
                    page,
                    size,
                    "itikaf-host-id": hostId,
                    "city-id": cityId,
                    "national-code": nationalCode && nationalCode.length > 0 ? nationalCode : null
                }
            ).then(resolve).catch(reject)
        })
    }

    getEtekafTransactionsList(
        page,
        size,
        startDateFilter,
        endDateFilter,
        phoneNumberFilter,
        statusFilter
    ) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `payment-transactions`,
                {
                    page,
                    size,
                    phoneNumber: phoneNumberFilter,
                    "start-pay-at": startDateFilter.length === 10 ? convertPersianDateToUniversalDate(startDateFilter) : "",
                    "end-pay-at": endDateFilter.length === 10 ? convertPersianDateToUniversalDate(endDateFilter) : "",
                    status: statusFilter !== paymentStatus.ALL.id ? statusFilter : ""
                }
            ).then(resolve).catch(reject)
        })
    }
}